import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { styled } from "styled-components";
import { Carousel, Tooltip } from "antd";
import dayjs from "dayjs";
import { keyframes } from "styled-components";

export async function getReview() {
  const response = await axios.get("/homepageReview?vetIdx=6");
  return response.data;
}

function Review() {
  const [windowWidth, setWindowWidth] = useState();

  const [dataList, setDataList] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(3); // 캐러셀 초기 슬라이더 갯수 설정

  const [animate, setAnimate] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let review_data = [
        {
            "idx": 11,
            "vetIdx": 6,
            "nickname": "김도리스",
            "imgUrl": "https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzA5MjFfMjMy%2FMDAxNjk1MjkzNDc2Mzcx.9FjMv04wrbabb0cHetuH1XbZKOOaSpG8FzBv0n2EGiQg.5zF3hfhnaBU5py4f3g9BUTO5dCptT44igVVFeRq45lEg.JPEG%2F1000001555.jpg",
            "content": "리뷰를 쭉 보니 고양이 쪽은 정말 잘 보시는 거 같아요. 특히 박설* 선생님이요 🥰 예전에 2차 병원 다니다가 상태만 안좋아지고 돈은 돈대로 썼는데 병원과 약을 끊으니 오히려 나았던 적이 있어서 불신이 가득했습니다. 이번에도 어쩔 수 없이 방문했던터라 최소한의 저치만 해야지 했는데 그동안 안 잡히던 이유 모를 구토와 설사가 잡혔어요. 한달 정도 먹고 있어서 약을 끊으면 어찌될지는 모르지만 일단 지금으로서 만족합니다. 비싸긴 디지게 비싸지만 이녀석이 지금 당장 건강한 상태인 것만으로도 감사합니다.",
            "regDate": "2023-09-10"
        },
        {
            "idx": 12,
            "vetIdx": 6,
            "nickname": "kom****",
            "imgUrl": null,
            "content": "밤늦게 우리아이 진료 봐주셨던 윤기홍 선생님. 감사하다고 글 남깁니다. 아이는 이제 하늘에 별이 되었지만, 끝까지 아이에게 진심으로 최선을 다 해주신 모습에 진심으로 감사함을 느꼈습니다. 처음 겪는 모든 일들에 지금도 당황스럽고 실감이 나지는 않지만, 선생님 덕분에 조금이나마 마음을 가라앉힐 수 있었던 것 같습니다. 아이가 좋은 선생님을 너무 늦게 만난 것 같아 아쉽습니다.",
            "regDate": "2023-09-08"
        },
        {
            "idx": 2,
            "vetIdx": 6,
            "nickname": "myl****",
            "imgUrl": "https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzExMjdfMTE3%2FMDAxNzAxMDU0MDM5NzU2.Td7qnERn4DwWSZ20a6MXYaZc2SqZAwjrj4Z8rqrl3HAg.MY7KMzkfBJ_czTm5fk4PkZjX9d-sTVCnuSrYmMiyAKog.JPEG%2F20231125_212402.jpg",
            "content": "미소 보호자입니다\n\n박설기 과장님께 감사한 마음 전하고자 합니다\n\n미소는 약 3개월 투병후\n25일 저녁에 무지개다리를 건넜습니다\n\n그동안 미소에 신경 써주시고\n진심어린 진료해주신 박과장님 감사합니다\n\n아프지 않게 보내고 싶었지만\n그 결정을 내려야하는 시간도\n보호자한테는 많이 힘들었어요\n다행히도 미소는 잘 참아주었고\n품에서 자는듯이 이별을 했습니다\n\n미소야 아프지말고 담에 또 만나자\n\n\n반려동물이 아프다고 직접 병원에 전화할수 없고\n보호자가 병원과 소통하는 특수한 상황인\n동물병원이기에 힘드신건 알지만\n보호자와 공감해주시는 따뜻한 말 한마디가\n큰 위로가 됩니다\n\n가족을 믿고 맡길수 있는\n병원입니다\n\n(비용문제는 국가가 해결할 일이죠)",
            "regDate": "2023-11-15"
        },
        {
            "idx": 8,
            "vetIdx": 6,
            "nickname": "사랑이 누나",
            "imgUrl": "https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzA5MjNfODUg%2FMDAxNjk1NDM5MTAyMTAy.BbkfD9gmI0YmfbDgw7QYefNZ2Zu_Yyo6yr00RNAwhdog.m5jcexU7lh0k5Mv3w9MrIb0rItLmXSKl6pLF9GDoM_Ug.JPEG%2FFCEC95CE-C471-4961-9188-F5802DE36501.jpeg",
            "content": "갑자기 다리를 절어서 24시 찾아보고 급하게 갔는데 데스크 선생님들도 친절하시고 진료 봐주신 선생님도 넘나 친절해요\n2차병원이라 가격은 좀 나오지만 만족합니다",
            "regDate": "2023-09-20"
        },
        {
            "idx": 14,
            "vetIdx": 6,
            "nickname": "das****",
            "imgUrl": null,
            "content": "두달전 구조한 고양이가 귀를 너무 긁길래 일반 동물병원 다니다 호전이 없고 답답해 큰 병원 방문. 이 전 병원을 5일동안 3번이나 갔는데 검이경만 보고 딱히 원인을 찾지 못했는데 스카이에서 바로 원인찾고 치료 잘하던중 이번에 호흡수가 이상하게 빠르고 밥도 안먹어 다시 방문 검사후 나오시는 주치의 샘 표정이 묘하게 어둡단 느낌을 받고 진단결과 fip가 의심된다 소리를 듣고 멘붕 정신없이 입원하고 5일입원후 어제 퇴원함..데스크 선생님들 친절하고 주치의 송재성 샘 천사 빙의 되신건가 싶고 입원기간 내내 따로 아이상태 알려주시고 밥 안먹으니 손수 먹여주시고 치료로 힘들어하는 아이 자기자식처럼 달래주시고 저의 긴 얘기도잘 들어주심 귀치료때부터 지금까지 넘 감사 또 감사했음\n거의 동물병원계의 아인슈타인!",
            "regDate": "2023-08-21"
        },
        {
            "idx": 13,
            "vetIdx": 6,
            "nickname": "lovelymei37",
            "imgUrl": null,
            "content": "꼼꼼하게 아이 잘 케어해 주셔서 감동이였습니다.\n재검진 하러 여러번 와야 했는데 올때마다 친절하시고 환자에게 잘 맞춰주세요😀",
            "regDate": "2023-08-21"
        },
        {
            "idx": 9,
            "vetIdx": 6,
            "nickname": "에디샤",
            "imgUrl": null,
            "content": "큰병원 가야하는 상황이라면 다른 동물병원가서 큰 돈 쓰지말고 여기서 진료 받으세요 ㅠㅠ 박설기 과장님 덕분에 우리 털동생 2달 넘게 고열 원인 못찾던거 드디어 원인 알고 열 내렸어여 ㅠ 진작 여기로 안데려온게 후회스럽습니다 ㅠ",
            "regDate": "2023-09-14"
        },
        {
            "idx": 3,
            "vetIdx": 6,
            "nickname": "dw****",
            "imgUrl": null,
            "content": "원장님 친절하시고 설명도 잘 해주셨어요 직원분들도 친절하시고 시설도 깨끗해요",
            "regDate": "2023-11-02"
        },
        {
            "idx": 15,
            "vetIdx": 6,
            "nickname": "담요8681",
            "imgUrl": null,
            "content": "12살 울 애기 여기서 영상 검사,수술 다 했어요\n나이가 있어서 3번의 마취 너무 걱정됐지만\n다행이 3번다 잘 깨어났어요 ㅠ 이번에 발작(?)을 시작해서 너무 속상했는데 심한건 아니라고 하셔서 약물 관리로 발작하는 횟수가 확실히 줄었어요 장염도 주기적으로 찾아와서 매번 약 받아 먹이는데 금방 잡혀요 2년 넘게 여기서 관리하고 있고 약도 잘 들고 하루 한끼만 먹던 애기가 지금은 스스로 두끼 꼬박꼬박 먹고 거기에 약이랑 섞어주는 밥까지 너무 잘 먹어서 살도 찌고 있어요 울 애기 얼마나 편했으면 배까고 자고 병원에서 보내준 사진도 배까고 있어요 내과, 외과, 영상 과장님 다른 의료진 선생님들도 정말 감사합니다🥹믿고 맡길 수 있는 병원이 있어 정말 든든합니다✌🏻",
            "regDate": "2023-08-16"
        },
        {
            "idx": 17,
            "vetIdx": 6,
            "nickname": "루이네냥",
            "imgUrl": null,
            "content": "진짜 두번다시 아이를 못보게될줄 알앗던\n그때가 잇엇네여ㅜㅜ\n림포마와 ibd 질병을 가지고 잇는터라\n입원과 수술을 반복하며\n1년 가까이 병원 생활을 한것 같아여\n지금은 중간중간 약처방과\n점검? 차원에서 가는데\n남은시간동안 아이가 편안하길 바라며\n그때까진 계속 병원 도움을 받아야 할것 같네요",
            "regDate": "2023-07-26"
        },
        {
            "idx": 16,
            "vetIdx": 6,
            "nickname": "J4254",
            "imgUrl": null,
            "content": "아이가 구토해서 야간 오전시간에 다녀왔는데\n바쁘신데도 불구하고 감사하게도\n자세히 봐주시고 친절하게 설명도 잘 해주셨습니다\n입원을 안하게 되서 너무 다행이었어요 ㅠㅠ",
            "regDate": "2023-08-16"
        },
        {
            "idx": 10,
            "vetIdx": 6,
            "nickname": "에디샤",
            "imgUrl": "https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzA5MTFfNDcg%2FMDAxNjk0NDEyNjE2ODY0.LxBFKRTDMHQqYVbGVIiZMujtLhSnreAGj_l_BNhzEmUg.Z7_JseodJ6yDK3eL9qK-93s9Z3wl6GFX1deowbsCJEog.JPEG%2F20230907_155439.jpg,https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzA5MTFfNTgg%2FMDAxNjk0NDEyNjE3NzU4.5aMBQh_HkjAWcLmIFpgtrQ1ZhcRS04Gl7OQI1erYE2Yg.-_Dou7zBNGYcCIZ8xm6cJb-s_BgDxKid1FD-bcZZj1Yg.JPEG%2F20230907_155453.jpg,https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzA5MTFfMTMw%2FMDAxNjk0NDEyNjE5ODU3.MGAHUVzJpZ0JoRllnuLzdIqevqIDBKUwk300LCh3fTsg.REFJU4IrqsHqng7dYxWNUh9PXw9pjxqAVNGT9dqpTXQg.JPEG%2F20230907_155450.jpg,https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzA5MTFfMjM2%2FMDAxNjk0NDEyNjIwMzI3.FyNcxjkthngrYNlUKZryHru-qOAiX4MQ3iJ5WvOiJM0g.hFJq7_w0v4pwWa-S6k5AW6wcpdTJ4YaVivIGRzNYaNIg.JPEG%2F20230907_181807.jpg",
            "content": "2달 넘게 원인 모를 고열과 높은 염증수치로 고생해온 우리 강아지 다니던 병원에서 추천해주셔서 내원했는데 비용때문에 걱정했으나 박설기 선생님이 지난 2달동안 다녀온 병원들 검사결과들 꼼꼼이 보시고 타병원 선생님들과 전화통화까지 해주시면서 꼭 해야하는 검사만 해주시고 또 단번에 원인도 알게해주셨습니다. 생각 못한 결과였어서 지금도 마음이 너무 아프지만 따듯하고 정확한 진단과 조언들 감사드려요. 데스크 선생님들도 너무 친절히 응대해주셔서 감사합니다. 젤 첨에 ㅅ래동물병원으로 갔었는데... 애초에 여기로 왔어야했어요 ㅠㅠㅠ",
            "regDate": "2023-09-11"
        },
        {
            "idx": 6,
            "vetIdx": 6,
            "nickname": "cc아몬드cc",
            "imgUrl": "https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzEwMjRfMjg3%2FMDAxNjk4MTE4MjMyNjM4.Fm4DicTyzpOBsOV8RJdJvlK3X-tF7shPXXrfgF7PDNwg.RBA4Ubg2tAlzH4M2JtIaPEn-01U1AJkYOEwlWD795vMg.JPEG%2F1698118110987.jpg",
            "content": "구름이가🐶 갑자기 신부전이와서 계속 입원하고 수치 내려가서 퇴원했는데 진료과정에서 종양이 보이고 간수치도 넘 높아서 수술했어요 🥺\n넘 위험한 수술이라 하는게 맞나,, 했다가 더 안좋아지면 어쩌나 고민 많았지만 그래도 정태규과장님 덕에 ㅠ.ㅠ 믿고 수술했어요👍🏻\n애기가 수술 후 밥을 잘 안먹으니까 손으로 직접 먹여주시는 모습에 넘 감동했어요 ㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠ흐에ㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠㅠ 감사해요",
            "regDate": "2023-10-17"
        },
        {
            "idx": 1,
            "vetIdx": 6,
            "nickname": "tjs****",
            "imgUrl": null,
            "content": "처음가봤는데 깨끗하고 견주로서 답답한마음에 질문을많이물어봤는데 친절하게 답변해줘서 감사했어요",
            "regDate": "2023-12-05"
        },
        {
            "idx": 7,
            "vetIdx": 6,
            "nickname": "꽃맘2",
            "imgUrl": "https://search.pstatic.net/common/?src=https%3A%2F%2Fpup-review-phinf.pstatic.net%2FMjAyMzA5MjNfMjEw%2FMDAxNjk1NDQzNzgwODcy.WBk5nLwDteKJN1gbesdh-aBLJsya4uGMsHwQb1Co5hwg.bHgN4uttmyIR6JdEMFpKhP9oIXbLOqj8XFJUXaPOAl0g.JPEG%2F1693364344671.jpg.jpg",
            "content": "같이사는 강아지한테물려서ㅠ 24시스카이동물병원 갔어요 야간진료봐주시던 선생님들 모두 친절하시고 걱정많이하시니까 사진도 보내주시고 외과선생님들이 수술부터 수술후 치료까지 잘해주셔서 우리애기 잘 회복중입니다. 수의사선생님들과 간호사선생님들 친절하게 잘 챙겨주셔서 감사드립니다. 믿고 맡길수있는 병원이있어 다행이네요",
            "regDate": "2023-09-23"
        },
        {
            "idx": 5,
            "vetIdx": 6,
            "nickname": "lovelymei37",
            "imgUrl": null,
            "content": "강아지 두마리 진료보는 것 때문에 정신없이 병원만 다니고 있네요. 예약해도 기본 1시간 기다리는 거 같아요 … 병원만 오면 기본 2시간 후딱 지나가네요 … 선생님들은 잘 봐주시는 거 같아요. 제가 많이 질문해서 그런건지 모르겠지만 세세하게 잘 알려주세요.",
            "regDate": "2023-10-26"
        },
        {
            "idx": 4,
            "vetIdx": 6,
            "nickname": "lovelymei37",
            "imgUrl": null,
            "content": "기존에 다니던 곳에서 수술 견적 150만원 좀 안되게 받고 아이가 심장이랑 호흡기가 좀 안좋아서 메디칼 가서 다시 견적 받았는데 350만원 조금 넘게 배로 들었습니다. 기존에 가던 병원에서는 동네병원에서 하는 거랑 대학병원/종합병원가서 하는거랑 다른 거 같이 생각하시면 된다고 하시는데. 저희 강아지가 심장도 약하고 호흡기도 좀 약해서 수술전 꼼꼼히 검사하고 (80만원정도) 메디칼에서 수술 들어갔습니다. 저도 안해본 수술을 3kg도 안되는 강아지가 배의 절반을 개복해서 탈장, 중성화, 종괴제거를 한꺼번에 한다는 게. 수술 전에도 진료 2번 더 보고. 끝까지 세세하게 체크하고 수술 들어갔습니다. 수술은 다행히 잘 됐고. 선생님들도 회복실에 있는 아이 사진 보내주시고 먹는거 동영상 찍어서 보내주시고. 만족해요.",
            "regDate": "2023-10-30"
        }
      ];
      setDataList(review_data);
      // try {
      //   // API 호출
      //   const res = await getReview();
      //   // 데이터 받아오면 상태 업데이트
      //   if (res.result === "ok") {
      //     setDataList(res.data);
      //     console.log(res.data);
      //   } else console.log(res.result);
      // } catch (error) {
      //   console.error("Error fetching review data:", error);
      // }
    };

    fetchData(); // 함수 호출
  }, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

  useEffect(() => {
    const handleScroll = () => {
      // 예시: 화면의 중간에 도달했을 때 애니메이션을 실행하려면
      // const midScreen = window.innerHeight * 5.5;
      const componentTop = componentRef.current.getBoundingClientRect().top;

      // console.log('innerHeight : ', window.innerHeight);
      // console.log('scrollY : ', window.scrollY);
      // console.log('midScreen : ', midScreen);
      if (componentTop < window.innerHeight) {
        setAnimate(true);
      }
      // else {
      //   setAnimate(false);
      // }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      // 컴포넌트 언마운트 시 이벤트 리스너 제거
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);

      // 화면 크기에 따라 slidesToShow 값을 동적으로 변경
      if (window.innerWidth < 576) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    // 컴포넌트 마운트 시 초기 값 설정
    handleResize();

    // 창 크기가 변경될 때마다 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const maskedNickname = (nickname) =>
    nickname.substring(0, 2) + "*".repeat(nickname.length - 2);

  return (
    <>
      <Container>
        <TextWrapper ref={componentRef}>
          <div className={animate ? "animate" : ""}>
            <p style={{ margin: 0 }}>Review</p>
            <h2 style={{ margin: 0, marginBottom: "16px" }}>
              <strong>리/얼/후/기</strong>
            </h2>
          </div>
        </TextWrapper>
        <CarouselContainer>
          <StyledCarousel
            slidesToShow={slidesToShow}
            autoplay={true}
            autoplaySpeed={5000}
            dots={false}
            // dotPosition="bottom"
          >
            {dataList.map((item, index) => (
              <div key={item.idx}>
                <div
                  style={{
                    margin: "5px 20px",
                    boxSizing: "border-box",
                  }}
                >
                  {slidesToShow === 2 ? (
                    <Tooltip
                      title={item.content}
                      overlayStyle={{
                        letterSpacing: "1px",
                        lineHeight: "1.5",
                        maxWidth: "400px",
                      }}
                      overlayInnerStyle={{
                        // backgroundColor: "whitesmoke",
                        // color: "#000",
                        padding: "10px 20px",
                      }}
                    >
                      <div
                        style={{
                          minHeight: "300px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          textAlign: "center",
                          padding: "20px",
                          borderRadius: "20px",
                          boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                          // border: "1px solid #ccc",
                          // backgroundColor: "#e2edf6",
                        }}
                      >
                        <div>
                          <p className="name">
                            {maskedNickname(item.nickname)}님의 리뷰
                          </p>
                          <p className="content">
                            {dayjs(item.regDate).format("YYYY.MM")}
                          </p>
                          <p className="content">
                            {windowWidth < 576 || windowWidth > 768
                              ? item.content
                              : truncateText(item.content, 100)}
                          </p>
                        </div>
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      style={{
                        minHeight: "300px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        textAlign: "center",
                        padding: "20px",
                        borderRadius: "20px",
                        boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                        // border: "1px solid #ccc",
                        // backgroundColor: "#e2edf6",
                      }}
                    >
                      <div>
                        <p className="name">
                          {maskedNickname(item.nickname)}님의 리뷰
                        </p>
                        <p className="content">
                          {dayjs(item.regDate).format("YYYY.MM")}
                        </p>
                        <p className="content">
                          {slidesToShow === 2
                            ? truncateText(item.content, 100)
                            : item.content}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </StyledCarousel>
        </CarouselContainer>
      </Container>
    </>
  );
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%; /* 가로 폭 100%로 설정 */
  padding: 5rem 1rem;
  /* margin: 50px 42px 60px 42px; */
  /* background-color: whitesmoke; */
  & .name {
    font-size: 1.2rem;
    font-weight: 700;
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
`;

const StyledCarousel = styled(Carousel)`
  .slick-dots {
    padding: 0; /* 기존 패딩 초기화 */
    list-style: none; /* 리스트 스타일 제거 */

    li {
      margin-right: 8px; /* 도트 간 여백 조절 */
      button {
        margin-top: 40px; /* 기존 마진 초기화 */
        width: 8px; /* 도트 크기 조절 */
        height: 8px;
        border-radius: 50%; /* 도트를 원 모양으로 만들기 */
      }
    }
  }
`;

const TitleWrapper = styled.div`
  width: 80%;
  height: fit-content;
  @media screen and (max-width: 690px) {
    padding-bottom: 2rem;
  }
  padding-bottom: 4rem;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: #000048;
      font-size: 3rem;
      margin: 0;
    }
    p {
      color: #000048;
      margin: 5px;
    }
  }
`;

const slideDown = keyframes`
    from {
        transform: translate(0, -50%);
        opacity: 0;
    }
    to {
        transform: translate(0,0);
        opacity: 1;
    }
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #403631;

  @media screen and (max-width: 500px) {
    justify-content: center;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      font-size: 2.5rem;
      font-weight: normal;
      @media screen and (max-width: 690px) {
        font-size: 2rem;
      }
    }
    p {
      font-weight: bold;
      font-size: 0.9rem;
      opacity: 0.6;
    }
  }

  .animate {
    animation: ${slideDown} 4s ease;
  }
`;

export default Review;
